import{Z as o,d as s}from"./p-DKOh0pH6.js";const p=o;const t=s;export{p as ZprModal,t as defineCustomElement};
//# sourceMappingURL=zpr-modal.js.map